<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid"  @keyup.enter.native="getBindPhoneListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model.trim="searchForm.userPhone" @keyup.enter.native="getBindPhoneListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商：">
                <el-select v-model="searchForm.supplierCode" placeholder="请选择" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select> 
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getBindPhoneListHandler">查询</el-button>
                <el-button type="success" plain icon="el-icon-download" @click="confirmExportDialogVisible = true">导 出</el-button>
                <el-button type="success" plainicon="el-icon-s-ticket"  @click="showBatchChgStateHandler12()">导 入</el-button>
                 <el-button type="danger" plainicon="el-icon-s-ticket"  @click="showBatchChgStateHandler122()">删 除</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border
		 fit
		 highlight-current-row
		 style="width: 100%;"
		 :header-cell-style="{background:'#f5f5f5'}"  >
            <el-table-column label="ICCID号" width="160" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userPhone" label="手机号"  align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="绑定时间"  align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="idcard" label="身份证号"  align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="idcardRemark" label="实名详情"  align="center" show-overflow-tooltip></el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportHandle">确 定</el-button>
            </span>
        </el-dialog>

          <el-dialog :append-to-body="true"  title="导入手机号" :visible.sync="batchOptVisible12" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm"   label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel"> 
                    <el-upload ref="upload" :action="uploadUrl('bindPhone/import/phone')" :headers="setHeader()" :auto-upload="false" :data="searchForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="downPdf()">导入模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler12">确 定</el-button>
            </div> 
        </el-dialog>       

         <el-dialog :append-to-body="true"  title="删除手机号" :visible.sync="batchOptVisible122" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm"   label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel"> 
                    <el-upload ref="upload" :action="uploadUrl('bindPhone/delete/phone')" :headers="setHeader()" :auto-upload="false" :data="searchForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="downPdf1()">删除模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler122">确 定</el-button>
            </div> 
        </el-dialog>       

    </div>
</template>

<script>
import {getBindPhoneList, exportRecord} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
             addOrEditPkgForm: {
                shopName:'',
                emsCode:'',
                disposeState:'',
                disposeRemark:'',
                newPhone:'',
                orderNo:'',
                account:'',
                pwd: '',
                supplierName: '',
                pwdkey:'',
                supplierShopName:'',
                htmlType:'',
                yongjingInfo:'',
                shopInfo:'',
                pkgType:'',
                agentPrice:'',
                agentPriceParent:''
                         
            },
            batchOptVisible12:false,
            searchForm: {
                iccid: '',
                userPhone: '',
                supplierCode:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            branchSupplierOption:[],
            batchOptVisible122:false,
            confirmExportDialogVisible: false,
        }
    },
    methods: {
         downPdf(){
            var link = document.createElement('a');
                link.setAttribute('download', '');
                link.href = '../../../doc/导入手机号模板.xls';
                link.click();
        },
         downPdf1(){
            var link = document.createElement('a');
                link.setAttribute('download', '');
                link.href = '../../../doc/删除手机号.xls';
                link.click();
        },
         handleSuccess(res){
            if(res.code == 200){
                this.batchOptVisible12 = false;
                 this.batchOptVisible122 = false;
                this.getBindPhoneListHandler();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
         showBatchChgStateHandler12(){
            this.batchOptVisible12 = true;
        },
          showBatchChgStateHandler122(){
            this.batchOptVisible122 = true;
        },
         cancel(){
               this.batchOptVisible12 = false;
                this.batchOptVisible122 = false;
            this.$refs.addOrEditPkgForm.resetFields();  
        },
          sureBatchChgStateHandler12(){ 
            this.$refs.searchForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
                this.batchOptVisible12=false;
                 this.$message.success('导入成功！');
               this.getBindPhoneListHandler();


            });
            

        },
         sureBatchChgStateHandler122(){ 
            this.$refs.searchForm.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
                this.batchOptVisible122=false;
               this.getBindPhoneListHandler();


            });
            

        },
        getBindPhoneListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getBindPhoneList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        exportHandle(){
            exportRecord(this.searchForm).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }
                this.confirmExportDialogVisible = false;
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getBindPhoneListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getBindPhoneListHandler();
        }
    },
    created(){ 
             common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
        this.getBindPhoneListHandler();
    }
}
</script>

<style lang="less" scoped>

</style>

